import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';
import { LabTestIdentity } from '../../sponsor/lab-results/lab-test';
import { StudyBuildPart } from './study-build-part';

export class TrendAnalysisBuildPart extends BaseBuildPart {
    constructor(private readonly trendAnalysisHelperParams: HelperParams,
                parent: StudyBuildPart,
                labTest: LabTestIdentity) {
        super(trendAnalysisHelperParams, parent, labTest ? ['trend-analysis', labTest.zcTestCode] : ['trend-analysis']);
    }

    public trends(): BaseBuildPart {
        return new BaseBuildPart(this.trendAnalysisHelperParams, this, ['trends']);
    }

    public siteBoxPlot(): BaseBuildPart {
        return new BaseBuildPart(this.trendAnalysisHelperParams, this, ['site-boxplot']);
    }

    public visitBoxPlot(): BaseBuildPart {
        return new BaseBuildPart(this.trendAnalysisHelperParams, this, ['visit-boxplot']);
    }
}